import { ActionIcon, Badge, Box, Button, Divider, Grid, Group, Image, Loader, Paper, Switch, Text, Title, UnstyledButton, useMantineTheme } from '@mantine/core';
import { notifications, showNotification } from '@mantine/notifications';
import React, { useEffect, useState } from 'react';
import { FaArrowLeft, FaCheck, FaLongArrowAltRight, FaTimes } from 'react-icons/fa';
import InputField, { InputFieldTypes } from '../components/input_field';
import { PaymentForm } from '../components/payment_form';
import { useApp } from '../contexts/app.context';
import { useAuth } from '../contexts/auth.context';
import { RECHARGE_WALLET, SAVE_COMPANY_PLAN, SEARCH_COUPON } from '../services/companies';
import { GET_ALL_PLANS } from '../services/plans';
import { extenseRecurrenceType } from '../utility/util';
import { GET_STRIPE_CONFIGS, SAVE_PAYMENT_METHOD } from '../services/payments';
import { useLanguage } from '../contexts/language.context';
import { useNoCaptcha } from '../hooks/useNoCaptcha';

declare const require: any;

export default function Recharge({ onClose = null }: { onClose?: (() => void) | null }) {
    const [loadingSave, setLoadingSave] = useState(false);
    const [formData, setFormData] = useState<any>({
        credits: 50,
        minutes: 10,
    });
    const [searchCoupon, setSearchCoupon] = useState<string>("");
    const [coupons, setCoupons] = useState<any>({});

    const theme = useMantineTheme();

    const { startPlan, agents } = useApp();
    const { str } = useLanguage();
    const { userData, loadUserData, ip } = useAuth();
    const { ready: noCaptchaReady, getNoCaptcha } = useNoCaptcha();

    const isPackagePlan = userData?.plan?.plan_type === "packages" || userData?.wlPlan?.plan_type === "packages";
    const activePlan = userData?.plan;
    const addOns = activePlan?.add_ons ?? [];
    const currency = activePlan?.currency ?? "USD";

    console.log(activePlan)
    const parsedAddOns = [...addOns]
        .map((addon: any) => ({
            minMinutes: parseInt(addon?.minMinutes ?? 0),
            maxMinutes: parseInt(addon?.maxMinutes ?? 0),
            pricePerMinute: parseFloat(addon?.pricePerMinute ?? 0),
        }))
        .filter((addon: any) => !isNaN(addon.minMinutes) && !isNaN(addon.maxMinutes) && !isNaN(addon.pricePerMinute))
        .sort((a: any, b: any) => a.minMinutes - b.minMinutes);

    const minimumMinutes = 10;

    const calculateMinutesPrice = () => {
        if (!isPackagePlan) return formData.minutes;

        const minutes = parseInt(formData.minutes ?? 0);
        if (parsedAddOns.length === 0) return minutes;
        
        const relevantTier = parsedAddOns.find((addon: any) =>
            minutes >= addon.minMinutes && minutes <= addon.maxMinutes
        );

        if (relevantTier) {
            return minutes * relevantTier.pricePerMinute;
        }

        if (minutes < parsedAddOns[0].minMinutes) {
            return minutes * parsedAddOns[0].pricePerMinute;
        }

        return minutes * parsedAddOns[parsedAddOns.length - 1].pricePerMinute;
    };

    const handleSave = async () => {
        if (formData?.payment?.method) {
            setLoadingSave(true);
            if (formData?.payment.method === "new-card") {
                try {
                    const { awaz } = await GET_STRIPE_CONFIGS("awaz")
                    const stripe = require('stripe')(awaz);
                    const pm = await stripe.paymentMethods.create({
                        type: 'card',
                        card: formData?.payment?.card,
                    })
                    const method = await SAVE_PAYMENT_METHOD("awaz", pm, { email: userData.company.email, name: userData.company.name })
                    finishSave(method.id, { push: true });
                } catch (err: any) {
                    setLoadingSave(false)
                    notifications.show({ message: err?.message ?? "Stripe not configured" });
                }
            } else {
                finishSave(formData?.payment?.method);
            }
        } else {
            notifications.show({ message: str("BILLING.CHOOSE_A_PAYMENT_METHOD") });
        }
    }

    const finishSave = async (method: any, others: any = {}) => {
        const captchaToken = await getNoCaptcha("payment");
        setLoadingSave(true);

        const payloadKey = isPackagePlan ? "minutes" : "credits";
        RECHARGE_WALLET({ 
            [payloadKey]: formData[payloadKey],
            payment: { method, ...others }, 
            captchaToken 
        })
            .then(res => {
                setLoadingSave(false);
                startPlan(false);
                if (res.payed) {
                    loadUserData();
                } else {
                    if (res.return_url) window.open(res.return_url, "_blank");
                    else notifications.show({ message: "You need to finish the payment process in your bank. Check for notifications and approve the transaction to finish", color: "yellow" })
                }
            })
            .catch(err => {
                setLoadingSave(false)
                notifications.show({ message: err.message, color: "red" })
            })
    }

    // useEffect(() => {
    //     if(searchCoupon.length > 3) SEARCH_COUPON(searchCoupon)
    //     .then(res => {
    //         setCoupons(c => ({...c, [searchCoupon]: res }))
    //     })
    //     .catch(err => {
    //     })
    // }, [searchCoupon]);

    return <Box p="md">
        <Grid>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Group>
                    <ActionIcon size="xl" variant="outline" color="gray" onClick={() => onClose && onClose()}><FaArrowLeft /></ActionIcon>
                    <Title order={3}>Checkout</Title>
                </Group>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Paper style={{ borderColor: "#DFDFDF" }} p="xl">
                    <Group align="flex-start">
                        <Box style={{ flex: 1 }}>
                            <Title order={3}>{isPackagePlan ? "Add Minutes to your plan" : "Recharge your wallet"}</Title>
                        </Box>
                        <Box>
                            <Group align='flex-end' gap="1px">
                                <Title size="22px">{currency} {parseFloat(isPackagePlan ? calculateMinutesPrice() : formData.credits).toFixed(2)}</Title>
                            </Group>
                            {isPackagePlan ? (
                                <InputField
                                    title="Add Minutes"
                                    name="minutes"
                                    fieldType={InputFieldTypes.QUANTITY}
                                    value={formData.minutes}
                                    min={minimumMinutes}
                                    onChange={({ minutes }: { minutes: any }) => {
                                        const incoming = parseInt(minutes ?? 0);
                                        const current = parseInt(formData.minutes ?? minimumMinutes);

                                        let nextMinutes = current;
                                        if (incoming > current) {
                                            nextMinutes = current + 10;
                                        } else if (incoming < current) {
                                            nextMinutes = current - 10;
                                        }

                                        setFormData((fd: any) => ({ ...fd, minutes: Math.max(nextMinutes, minimumMinutes) }));
                                    }}
                                    size="xs"
                                />
                            ) : (
                                <InputField
                                    title="Add Credits"
                                    name="credits"
                                    fieldType={InputFieldTypes.QUANTITY}
                                    value={formData.credits}
                                    min={10}
                                    onChange={({ credits }: { credits: any }) => {
                                        const nextCredits = parseFloat(credits ?? 0);
                                        setFormData((fd: any) => ({ ...fd, credits: Math.max(nextCredits, 10) }));
                                    }}
                                    size="xs"
                                />
                            )}
                        </Box>
                    </Group>
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 7 }}>
                <Paper style={{ borderColor: "#DFDFDF" }} p="xl">
                    {
                        // (formData?.creits) > 0 && 
                        <>
                            <Title order={4}>Payment Method</Title>
                            <Box mt="sm">
                                <PaymentForm
                                    data={formData?.payment}
                                    methods={userData.paymentMethods}
                                    onChange={(dt: any) => setFormData((fd: any) => ({
                                        ...fd,
                                        payment: { ...fd?.payment, ...dt }
                                    }))}
                                />
                            </Box>
                        </>
                    }
                </Paper>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 5 }}>
                <Paper style={{ borderColor: "#DFDFDF" }} p="xl">
                    <Title order={4}>{str("TOTAL")}</Title>

                    <Paper mt="md" p="md" style={{ backgroundColor: theme.colors.dark[6], borderColor: "#DFDFDF" }}>
                        {isPackagePlan ? (
                            <>
                                {parsedAddOns.length > 0 && (
                                    <>
                                        <Text size="xs">Pricing Tiers:</Text>
                                        {parsedAddOns.map((addon: any, idx: number) => (
                                            <Text key={idx} size="xs" c="gray">
                                                {addon.minMinutes}-{addon.maxMinutes} min: {currency} {addon.pricePerMinute.toFixed(4)}/min
                                            </Text>
                                        ))}
                                        <Divider c="#DFDFDF" my="md" />
                                    </>
                                )}
                                <Text size="xs">Selected Minutes</Text>
                                <Text size="xs" mt="xs" fw="bold">
                                    {formData.minutes} minutes
                                </Text>
                                <Divider c="#DFDFDF" my="md" />
                                <Text size="xs">Total Amount</Text>
                                <Text size="xs" mt="xs" fw="bold">
                                    {currency} {calculateMinutesPrice().toFixed(2)}
                                </Text>
                            </>
                        ) : (
                            <>
                                <Text size="xs">Total Amount</Text>
                                <Text size="xs" mt="xs" fw="bold">{currency} {(formData?.credits ?? 0).toFixed(2)}</Text>
                            </>
                        )}
                    </Paper>
                </Paper>

            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 12 }}>
                <Button loading={loadingSave} onClick={handleSave} mt="lg" variant="filled" style={{ borderWidth: 1, borderColor: 'black' }} fullWidth size="lg" rightSection={<FaLongArrowAltRight />}>{str("CONFIRM")}</Button>
            </Grid.Col>
        </Grid>
    </Box>
}
